"use client";

import { useEffect, useState } from "react";

export type ScrollState = {
  scrolled: boolean;
  pastHero: boolean;
  progress: number;
};

export function useScrollState(): ScrollState {
  const [state, setState] = useState<ScrollState>({
    scrolled: false,
    pastHero: false,
    progress: 0,
  });

  useEffect(() => {
    let frame = 0;

    const measure = () => {
      frame = 0;
      const y = window.scrollY;
      const viewport = window.innerHeight;
      const scrollable = document.documentElement.scrollHeight - viewport;
      const progress = scrollable > 0 ? Math.min(1, Math.max(0, y / scrollable)) : 0;

      setState({
        scrolled: y > 24,
        pastHero: y > viewport - 72,
        progress,
      });
    };

    const onScroll = () => {
      if (frame === 0) frame = window.requestAnimationFrame(measure);
    };

    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return state;
}
